import {BillingTransaction} from './billing-transactions/billing-transaction';
import {
  useInfiniteData,
  UseInfiniteDataProps,
} from '@common/ui/infinite-scroll/use-infinite-data';
import {useActiveWorkspaceId} from '@common/workspace/active-workspace-id-context';

interface Params {
  userId?: string | number;
  published?: string;
  paginate?: UseInfiniteDataProps<undefined>['paginate'];
}

export function useBillingTransactions(params: Params) {
  const {workspaceId} = useActiveWorkspaceId();
  return useInfiniteData<BillingTransaction>({
    queryKey: ['billing-transactions', {...params, workspaceId}],
    endpoint: 'billing-transactions',
    paginate: params.paginate || 'simple',
    defaultOrderBy: 'updated_at',
    defaultOrderDir: 'desc',
    queryParams: {
      ...params,
      workspaceId,
    },
    willSortOrFilter: true,
  });
}
